import React from 'react';
import { Route } from 'react-router';
import * as Screens from '../screens';
import { errorRoutePaths } from './route-paths';
export const errorRoutes = [<Route path={errorRoutePaths.malformedUrl} element={<Screens.MalformedUrl />} key="malformed-url" />];